import { RootState } from 'config/store/rootReducer';
import { createSelector } from 'reselect';
import { PaginationInfo, SortValue } from 'types';
import { ImportedOrganization, ImportedOrganizationFilters } from '../../types/importedOrganization';

const getImportedOrganizations = (state: RootState): ImportedOrganization[] | null => {
  return state.importedOrganizations.importedOrganization.importedOrganizations;
};

const getTotalImportedOrganizations = (state: RootState): number => {
  return state.importedOrganizations.importedOrganization.pageInfo.totalItems;
};

const getFilters = (state: RootState): ImportedOrganizationFilters =>
  state.importedOrganizations.importedOrganization.filters;

const getPaginationInfo = (state: RootState): PaginationInfo =>
  state.importedOrganizations.importedOrganization.pageInfo;

const getSortingInfo = (state: RootState): SortValue[] => state.importedOrganizations.importedOrganization.sorting;

export const makeGetImportedOrganizations = () =>
  createSelector(getImportedOrganizations, (organizations: ImportedOrganization[] | null) => organizations);

export const makeGetTotalImportedOrganizations = () =>
  createSelector(getTotalImportedOrganizations, (totalImportedOrganizations: number) => totalImportedOrganizations);

export const makeGetImportedOrganizationFilters = () =>
  createSelector(getFilters, (filters: ImportedOrganizationFilters) => filters);

export const makeGetImportedOrganizationPageInfo = () =>
  createSelector(getPaginationInfo, (pageInfo: PaginationInfo) => pageInfo);

export const makeGetImportedOrganizationSorting = () =>
  createSelector(getSortingInfo, (sorting: SortValue[]) => sorting);
